import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  alpha,
  useTheme,
} from '@mui/material';

export default function LeadViewHistory({ row }) {
  const history = row?.history || [];
  const theme = useTheme();

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: theme.shadows[4],
        overflow: 'auto',
        maxHeight: 400, // Scrollable for many rows
        '&::-webkit-scrollbar': {
          height: 6,
          width: 6,
        },
        '&::-webkit-scrollbar-track': {
          background: alpha(theme.palette.grey[300], 0.5),
          borderRadius: 3,
        },
        '&::-webkit-scrollbar-thumb': {
          background: theme.palette.primary.main,
          borderRadius: 3,
        },
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1) }}>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              Action
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              Status
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              From Department
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              To Department
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              From Employee
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              To Employee
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              Changed By
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              Remarks
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              Date
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history.length > 0 ? (
            history.map((item, index) => (
              <TableRow
                key={item.history_id}
                sx={{
                  transition: 'all 0.2s ease',
                  '&:nth-of-type(odd)': {
                    bgcolor: alpha(theme.palette.grey[100], 0.6),
                  },
                  '&:hover': {
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    transform: 'translateY(-1px)',
                    boxShadow: theme.shadows[2],
                  },
                  '& td': {
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                    py: 1.5,
                  },
                }}
              >
                <TableCell>{item.actionTypeName}</TableCell>
                <TableCell>{item.statusName}</TableCell>
                <TableCell>{item.fromDepartmentName}</TableCell>
                <TableCell>{item.toDepartmentName}</TableCell>
                <TableCell>{item.fromEmployeeName}</TableCell>
                <TableCell>{item.toEmployeeName}</TableCell>
                <TableCell>{item.changedByName}</TableCell>
                <TableCell sx={{ maxWidth: 200, wordBreak: 'break-word' }}>{item.remarks}</TableCell>
                <TableCell sx={{ fontSize: '0.875rem', color: theme.palette.text.secondary }}>
                  {new Date(item.created_at).toLocaleDateString()}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9} align="center" sx={{ py: 4, color: theme.palette.text.disabled }}>
                No History Available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
